var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuality1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H1.59998V36.8H48V0Z",
    fill: "#CFD7E9",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5352 58.9163L28.462 40.9895L32.999 45.5266L15.0722 63.4533L10.5352 58.9163Z",
    fill: "#26DDF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6769 16.2795H42.9607V21.1935H37.6769V16.2795Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6775 26.5286H42.9613V31.4425H37.6775V26.5286Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1728 32.5655C23.1728 42.6457 31.3445 50.8174 41.4247 50.8174C51.5049 50.8174 59.6765 42.6457 59.6765 32.5655C59.6765 22.4853 51.5049 14.3137 41.4247 14.3137C31.3445 14.3137 23.1728 22.4853 23.1728 32.5655Z",
    fill: "#26DDF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1864 36.2855H23.5487C23.3 35.0844 23.1693 33.8401 23.1693 32.5652C23.1693 22.485 31.3409 14.3134 41.4212 14.3134C43.4358 14.3134 45.3742 14.6398 47.1864 15.2426V36.2855Z",
    fill: "#010304"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6517 32.0037C55.6517 39.8627 49.2807 46.2337 41.4217 46.2337V43.0454C47.5198 43.0454 52.4634 38.1018 52.4634 32.0037H55.6517Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality1);
export default __webpack_public_path__ + "static/media/quality_1.5da21c7798bc7acbfd110f94a81d6583.svg";
export { ForwardRef as ReactComponent };